import {ApiErrorKeys} from './constants'

export function isNextApiError(error) {
    return error.name && error.name === 'ApiError'
}

export function isNotFoundError(error, entityType) {
    const body = error.body
    return body.errorKey === ApiErrorKeys.NotFoundEntity && (!entityType || body.entityType === entityType)
}


// WEBPACK FOOTER //
// ./web/js/next/utils.js